module.exports = __webpack_public_path__ + "static/show_welfare.1828ca3a.png";